import Axios from 'axios'

import i18n from '@/i18n'
import { scrollToTop } from '@/helpers/utils'
import { SET_LOCALE, ADD_LOCALE_MESSAGES } from '@/store/mutation-types'

export default {
  state: {
    locale: null,
    availableMessages: []
  },
  getters: {
    isLocalMessagesLoaded (state) {
      return (locale) => {
        return state.availableMessages.indexOf(locale) !== -1
      }
    }
  },
  mutations: {
    [SET_LOCALE] (state, locale) {
      state.locale = locale
    },
    [ADD_LOCALE_MESSAGES] (state, locale) {
      state.availableMessages.push(locale)
    }
  },
  actions: {
    async setLocale ({ dispatch, commit }, locale) {
      await dispatch('loadLocaleMessages', locale)

      commit(SET_LOCALE, locale)
      scrollToTop()
    },
    async loadLocaleMessages ({ getters, commit }, locale) {
      if (!getters.isLocalMessagesLoaded(locale)) {
        const response = await Axios.get(`${process.env.WORDPRESS_HOME_CONTENT_API}/${locale}`)

        // i18n.setLocaleMessage(locale, response.data)
        i18n.mergeLocaleMessage(locale, response.data)

        commit(ADD_LOCALE_MESSAGES, locale)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/i18n.js